import {environment} from '../../../../environments/environment';
import {Component, OnInit, Inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import * as moment from 'moment' ;
import {ProjectService} from '../../../shared/services/project/project.service';
import {ActivatedRoute} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {faTimes} from '@fortawesome/free-solid-svg-icons/faTimes';
import {AuthenticationService} from '../../../shared/services/authentication/authentication.service';
import {HelperService} from '../../../shared/services/helper/helper.service';
import { JobTaskService } from '../../../shared/services/job-task/job-task.service';
import { faTasks } from '@fortawesome/free-solid-svg-icons/faTasks';
import { HttpStatusCode } from '../../../shared/enum/http-status-code.enum';
import { Unit } from '../../../shared/enum/unit.enum';
import { DataType } from '../../../shared/enum/data-type.enum';
import { JobTaskStatus } from '../../../shared/enum/job-task-status.enum';
import { MeasureFrom } from '../../../shared/enum/measure-from.enum';
import {ProjectMeasureGraphicStateService} from '../../../shared/services/project-measure-graphic-state/project-measure-graphic-state.service';

@Component({
    selector: 'app-project-export-csv',
    templateUrl: './project-export-csv.component.html',
    styleUrls: ['./project-export-csv.component.css']
})
export class ProjectExportCsvComponent implements OnInit {

    public isLoading: boolean = true;
    public hasError: boolean = false;
    public locations: any[] = [];
    public typesSelected: boolean = false;
    public dataTypesSelected: boolean = false;
    public unitsSelected: boolean = false;
    public now = new Date();
    public start_datePicker: Date;      // Binded to the date picker (Angular Material component)
    public end_datePicker: Date;
    public start_timePicker: INgbTimePicker;        // Binded to the time picker (NgBootstrap component)
    public end_timePicker: INgbTimePicker;
    public units: any[] = [
        {
            id: 'mm',
            selected: true,
            name: 'MILLIMETER'
        }, {
            id: 'mdef',
            selected: false,
            name: 'MICRODEF'
        }];
    public types: ISelectOptions[] = [
        {
            id: 'sta',
            selected: true
        }, {
            id: 'dyn',
            selected: false
        }, {
            id: 'rt',
            selected: false
        }];
    public dataTypes: ISelectOptions[] = [
        {
            id: 'raw',
            selected: true
        }];
    public showSms = 0;

    public offsets: ISelectOptions[] = [
        {
            id: 'offset',
            selected: true
        }];
    public locationsSelected: boolean = false;
    public idProject: number;
    public project: any = {};
    public faTimes = faTimes;
    public faTasks = faTasks;
    public locationSelected: number[] = [];

    private corThemDisplay: boolean;
    private injectedData: any;
    displayFeatureExportAsync = environment.display_feature_export_async;

    constructor(private projectService: ProjectService,
                private http: HttpClient,
                private route: ActivatedRoute,
                private toastr: ToastrService,
                private translate: TranslateService,
                public authenticationService: AuthenticationService,
                private helperService: HelperService,
                private jobTaskService: JobTaskService,
                @Inject(MAT_DIALOG_DATA) data: any,
                private projectMeasureGraphicStateService: ProjectMeasureGraphicStateService) {
    this.injectedData = data;
    }

    ngOnInit() {
        this.isLoading = true;
        this.idProject = this.injectedData.idProject;
        this.showSms = this.injectedData.showSms;
        this.locationSelected = this.injectedData.locationSelected !== undefined ? this.injectedData.locationSelected : [];
        this.types = this.injectedData.types !== undefined ? this.injectedData.types : this.types;
        this.offsets[0].selected = this.projectMeasureGraphicStateService.get('showOffset') || false;
        this.resetPicker('start', this.injectedData.start_date);
        this.resetPicker('end', this.injectedData.end_date);
        this.projectService.getProject(this.idProject, 'locations')
            .subscribe(
                (data: any) => {
                    this.project = data;
                    this.corThemDisplay = this.project && this.project.project_status_abo_maths && this.project.project_status_abo_maths.state > 0;
                    if (this.corThemDisplay) {
                        this.dataTypes.push({
                            id: 'thermal-correction',
                            selected: false
                        }, {
                            id: 'thermal-correction-recap',
                            selected: false
                        });
                    }
                    this.isLoading = false;
                    this.getProject();
                }
                ,
                error2 => {
                    this.isLoading = false;
                    this.hasError = true;
                }
            );
    }

    setShowSms(item) {
      this.showSms = item.value;
    }

    toggleSelection(prop) {
        let a = prop + 'Selected';
        this[a] = !this[a];
        this[prop].forEach((location) => {
            location.selected = this[a];
        });
    }

    setSelected(propertyName: string, id: number) {
        this[propertyName].forEach((el) => {
            if (el.id === id) {
                el.selected = !el.selected;
            }
        });
    }

    getCsv(mode: string = 'sync'): void {
        let dateStart, dateEnd;
        try {
          dateStart = this.checkAndFormatDate(this.start_datePicker, this.start_timePicker, 'start');
          dateEnd = this.checkAndFormatDate(this.end_datePicker, this.end_timePicker, 'end');
        } catch (e) {
          this.toastr.error('INVALID_DATES');
          return;
        }
        let invalidInputs = this.validateInputs(dateStart, dateEnd, this.locations, this.units, this.types, this.dataTypes);

        if (invalidInputs) {
            this.toastr.error(this.errorMessage(invalidInputs), this.translate.instant('ERROR'));
            return;
        }

        let rawData = this.dataTypes[0].selected;
        let corrThermData = this.dataTypes[1] ? this.dataTypes[1].selected : undefined;
        let corrThermDataRecap = this.dataTypes[2] ? this.dataTypes[2].selected : undefined;
        let staticFile = this.types[0].selected;
        let dynamicFile = this.types[1].selected;
        let rtFile = this.types[2].selected;
        let mm = this.units[0].selected;
        let mdef = this.units[1].selected;
        let offset = this.offsets[0].selected;
        let selectedLocation = this.locations.filter(
            (location) => location.selected
        );

        const token = this.authenticationService.getToken();
        const sleepTime = 200;
        const sms = this.showSms;

        if ('sync' === mode) {
          this.helperService.asyncForEach(selectedLocation, async (location) => {
            if (rawData === true) {
                const smsModule = '&fromsms=' + sms ;
                const showOffset: string = offset ? '&showOffset=1' : '';
                const commonChunk: string = environment.apiUrl + environment.guardedRoute +
                  `auth/export/raw/csv?token=` + token + `&dateStart=` + dateStart + `&dateEnd=` + dateEnd + smsModule + showOffset;
                if (staticFile === true) {
                    if (mm === true) {
                        window.open(commonChunk + `&location=` + location.id + `&type=sta&unit=mm&project=` + this.idProject, '_blank');
                        await this.helperService.sleep(sleepTime);
                    }
                    if (mdef === true) {
                        window.open(commonChunk + `&location=` + location.id + `&type=sta&unit=mdef&project=` + this.idProject, '_blank');
                        await this.helperService.sleep(sleepTime);
                    }
                }

                if (dynamicFile === true) {
                    if (mm === true) {
                        window.open(commonChunk + `&location=` + location.id + `&type=dyn&unit=mm&project=` + this.idProject, '_blank');
                        await this.helperService.sleep(sleepTime);
                    }
                    if (mdef === true) {
                        window.open(commonChunk + `&location=` + location.id + `&type=dyn&unit=mdef&project=` + this.idProject, '_blank');
                        await this.helperService.sleep(sleepTime);
                    }
                }

                if (rtFile === true) {
                    if (mm === true) {
                        window.open(commonChunk + `&location=` + location.id + `&type=rt&unit=mm&project=` + this.idProject, '_blank');
                        await this.helperService.sleep(sleepTime);
                    }
                    if (mdef === true) {
                        window.open(commonChunk + `&location=` + location.id + `&type=rt&unit=mdef&project=` + this.idProject, '_blank');
                        await this.helperService.sleep(sleepTime);
                    }
                }

            }
            // CT data
            if (corrThermData === true && this.corThemDisplay === true) {
                let chunckCorrTherm: string = environment.apiUrl + environment.guardedRoute + `auth/export/thermal-correction/csv?token=` + token + `&dateStart=` + dateStart + `&dateEnd=` + dateEnd;
                window.open(chunckCorrTherm + `&location=` + location.id);
                await this.helperService.sleep(sleepTime);
            }

        });
        // CT data Recap
        if (corrThermDataRecap === true && this.corThemDisplay === true) {
            let chunckCorrThermRecap: string = environment.apiUrl + environment.guardedRoute + `auth/export/thermal-correction-recap/csv?token=` + token + `&_format=csv`;
            window.open(chunckCorrThermRecap + `&project=${this.idProject}`, '_blank');
          }
        } else {
          this.handleAsyncExport(selectedLocation, dateStart, dateEnd, offset, sms);
        }
    }

    resetPicker(pickerToReset, date?: string) {
        let _date;
        if (date) {
            _date = new Date(date);
            const today = new Date();
            if (_date > today) {
              _date = today;
            }
        } else {
          _date = new Date();
        }
        this[pickerToReset + '_timePicker'] = {
          hour: _date.getUTCHours(),
          minute: _date.getUTCMinutes(),
          second: _date.getUTCSeconds()
        };
        this[pickerToReset + '_datePicker'] = moment(_date).format();
    }

    private fixTwo(number: number) {
        if (number < 10) {
            return '0' + number.toString();
        }
        return number;
    }

    private checkIfDateIsPassed(date: string) {
        let parsedDate = Date.parse(date);
        if (!parsedDate) {
            return moment().format();
        }
        return parsedDate - Date.now() > 0 ?
            moment().format()
            : date;
    }

    private checkAndFormatDate(datePickerValue, timePickerValue, action: 'start' | 'end'): string {
        if (!datePickerValue) {
          throw new Error('Invalid date');
        }
        if (Object.keys(timePickerValue).find(
            (value) => !value
        )) {
            return undefined;
        }
        const date = moment(this[action + '_datePicker']);
        if (!date.isValid()) {
          throw new Error('Invalid date');
        }
        const dateString = date.format('YYYY-MM-DDT');
        const timeString = this.fixTwo(this[action + '_timePicker'].hour) + ':' + this.fixTwo(this[action + '_timePicker'].minute) + ':'
          + this.fixTwo(this[action + '_timePicker'].second) + '.0000Z';
        return dateString + timeString;
    }

    private getProject() {
        if (!this.project || !this.project.project_device_locations) {
            return;
        }
        this.project.project_device_locations.forEach((d) => {
            d.selected = this.locationSelector(d.id);
            this.locations.push(d);
        });
    }

    private locationSelector(id: number) {
        return this.locationSelected.includes(id);
    }

    private validateInputs(dateStart, dateEnd, locations, units, types, dataTypes): string[] {

        // Check if all dates are defined
        let dates = [dateStart, dateEnd];
        let dateNames = ['start date', 'end date'];
        dateNames = dateNames.filter(
            (date) => !date
        );

        // Check if each list has at least one option selected
        let lists = [locations, units, types, dataTypes];
        let listNames = ['locations', 'units', 'types', 'data ty' +
        '' +
        '' +
        '' +
        'pes'];
        listNames = listNames.filter(
            (listName, index) => !(lists[index].find((option) => option.selected)));

        let invalidFields = [].concat(dateNames, listNames);
        if (invalidFields.length > 0) {
            return invalidFields;
        } else {
            return undefined;
        }
    }

    private errorMessage(invalidInputs: string[]) {
        let invalidFieldsList = invalidInputs.reduce(
            (string, field, index) => string + (index > 0 ? ', ' : ' ') + field, ''
        );
        return 'The following fields have to be filled :' + invalidFieldsList;
    }

    private handleAsyncExport(selectedLocation, dateStart, dateEnd, offset, sms) {
      const showOffset = offset ? 1 : 0;
      const startDate = moment(dateStart).format('YYYY-MM-DD');
      const endDate =  moment(dateEnd).format('YYYY-MM-DD');
      const staticFile = this.types[0].selected;
      const dynamicFile = this.types[1].selected;
      const rtFile = this.types[2].selected;

      let locationsIds = '';
      selectedLocation.forEach( function (location)  {
        locationsIds += 'location_ids[]=' + location.id + '&';
      });

      if (staticFile) {
        this.getAsyncExport(locationsIds, startDate, endDate, showOffset, DataType.STATIC);
      }

      if (dynamicFile) {
        this.getAsyncExport(locationsIds, startDate, endDate, showOffset, DataType.DYNAMIC);
      }

      if (rtFile) {
        this.getAsyncExport(locationsIds, startDate, endDate, showOffset, DataType.REALTIME);
      }
    }

    private getAsyncExport(locationsIds, startDate, endDate, showOffset, dataType) {
      let newStartDate: any;
      let newEndDate: any;
      const endDateProject =  moment(this.project.end_date).format('YYYY-MM-DD');
      const maxEndDate = moment().isAfter(endDateProject) ? endDateProject : moment().format('YYYY-MM-DD');

      if (dataType === DataType.STATIC) {
        newStartDate =  moment(startDate).year().toString() + '-01-01';
        newEndDate = moment(endDate).year().toString() + '-12-31';
      } else {
          newStartDate =  moment(startDate).startOf('month').format('YYYY-MM-DD');
          newEndDate = moment(endDate).endOf('month').format('YYYY-MM-DD');
      }

      if (newEndDate > maxEndDate) {
        newEndDate = maxEndDate;
        if (maxEndDate === endDateProject) {
          this.toastr.info(this.translate.instant('JOB_TASK_END_DATE_UPDATED_WITH_PROJECT_END'));
        } else {
          this.toastr.info(this.translate.instant('JOB_TASK_END_DATE_UPDATED_WITH_TODAY'));
        }
      }

      return this.jobTaskService.getAsyncExport(this.idProject, locationsIds, Unit.MICRODEF, dataType, newStartDate, newEndDate,
        showOffset, MeasureFrom.ALL)
        .subscribe( (response: any) => {
          if (HttpStatusCode.ACCEPTED === response.code) {
            this.toastr.info(this.translate.instant('JOB_TASK_MESSAGE_PENDING'));
          } else {
            const jobTask = response.message;
            if (jobTask.status === JobTaskStatus.STATUS_FAILED) {
                  this.toastr.error(this.translate.instant('JOB_TASK_MESSAGE_ERROR'));
            }

            if (jobTask.status === JobTaskStatus.STATUS_IN_PROGRESS) {
              this.toastr.info(this.translate.instant('JOB_TASK_MESSAGE_PENDING'));
            }

            if (jobTask.status === JobTaskStatus.STATUS_COMPLETED) {
              const filename = jobTask.filename.substr(0, 35);
              this.translate.get('JOB_TASK_MESSAGE_SUCCESS', {filename: filename, job_id: jobTask.id})
                .subscribe((result: string) => {
                  this.toastr.success(result);
                });
            }
          }
        });
    }
}


// Apparently no typing file in the TimePicker module
interface INgbTimePicker {
    hour: number;
    minute: number;
    second: number;
}

interface ISelectOptions {
    id: string;
    selected: boolean;
}
